var ReactTooltip = require("react-tooltip");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

require("writing/evaluations/text_area_markups.scss")

var HTML_TAG_PATTERN = /<\/?[^>]+(>|$)/gi;

class TextAreaMarkups extends React.Component {

	combineOverlapping(arr) {
		var sortedArr = arr.sort((a, b) => a.start - b.start);

		var combinedArr = [];

		if (sortedArr.length > 0) {
			var start = sortedArr[0].start;
			var end = sortedArr[0].end;
			var key = sortedArr[0].key;

			for (var i = 1; i < sortedArr.length; i++) {
				var current = sortedArr[i];
				if (current.start > end) {
					combinedArr.push({ start, end, key });
					start = current.start;
					end = current.end;
					key = current.key;
				} else if (current.end > end) {
					end = current.end;
				}
			}
			combinedArr.push({ start, end, key });
		}

		

		return combinedArr;
	}

	getMarkups() {
		if (this.props.markups) {
			// Legacy
			return this.props.markups;

		} else {
			var tagSpans = []
			_.each(_.flatten(_.values(this.props.tagging)), (tag) => {
				if (!_.size(tag.spans[0])) { return; }
				if (tag.key && tag.key == 'KNOWN_TEXT_GROUP') {
					var startSpan = tag.spans[0]
					var endSpan = tag.spans.pop();
					if (("start" in startSpan) && ("end" in endSpan)) {
						var span = { start: startSpan.start, end: endSpan.end }
						tagSpans.push(_.extend({}, span, { key: tag.key }))
					}
				} else {
					_.each(tag.spans || [], (span) => {
						if (("start" in span) && ("end" in span)) {
							tagSpans.push(_.extend({}, span, { key: tag.key }))
						}
					})
				}
				return ;
			})

			// combine overlapping concepts
			tagSpans = this.combineOverlapping(tagSpans)

			var markups = [];
			_.each(_.sortBy(tagSpans, "start"), (span) => {
				if ((markups.length == 0) || (span.end >= _.last(markups).end)) {
					markups.push(span)
				}
			})

			return markups;
		}
	}

	formatMarkups(markups) {
		var { activeLeaf } = this.props;

		if (markups.length) {
			return markups.map((d) => {
				if (activeLeaf && !_.isEmpty(activeLeaf.display_name)) {
					var tag = activeLeaf.display_name
				}
				else if (d["key"]) {
					var tag = AutograderDisplayConfig.getTagName(d["key"]) || d["key"];
				} else if (d["tag"]) {
					var tag = d["tag"];
				}

				if (("start" in d) && tag) {
					var defaultColor = "#faaf88";
					if (this.props.tagColors) {
						var color = this.props.tagColors[d["key"]] || defaultColor;
					} else {
						var color = d["color"] || defaultColor;
					}

					return {
						"start": parseInt(d["start"]),
						"end": parseInt(d["end"]),
						"tag": tag,
						"color" : color
					}
				} else {
					return null
				}
			}).sort(
				(x, y) => {
					if (y && x) {
						return x["start"] - y["start"];
					} else {
						if (x) {
							return 1
						} else {
							return -1
						}
						
					}
				}
	        );
		} else {
			return []
		}
	}

	formatString(text, markups) {
		markups = this.formatMarkups(markups);
		var stringArray = [];

		var lastSpanEnd = 0;
		_.each(markups, function(tag) {
			if (tag && (tag.start != undefined) && (tag.start < tag.end) && (tag.start >= lastSpanEnd)) {
				if (tag.start > lastSpanEnd) {
					var beforeSpan = text.substring(lastSpanEnd, tag.start);
					stringArray.push([beforeSpan, "", null]);
				}
				var inSpan = text.substring(tag.start, tag.end);
				stringArray.push([inSpan, tag.tag, tag.color]);
				lastSpanEnd = tag.end
			}
		});


		if (lastSpanEnd < text.length) {
			var afterSpan = text.substring(lastSpanEnd);
			stringArray.push([afterSpan, "", null]);
		}

		return stringArray
	}

	getElement(string_array) {		
		var index = 0
		var tag_list = []
		string_array.forEach(function(el){
			if (!tag_list.includes(el[1])) {
				tag_list.push(el[1])
			}
		}) 
		tag_list.sort()
		var array = string_array.map(function(el, i) {
			index += 1
			if (el[1].length) {
				el[0] = el[0].replace(HTML_TAG_PATTERN, "")
				var colors = el[2];
				var tagTitle = el[1];
				if (colors) {
					if (_.isArray(colors)) {
						var background = "repeating-linear-gradient(" + 
							"45deg, " + colors[0] + ", " + colors[0] + " 10px, " + colors[1] + " 10px, " + colors[1] + " 20px)";
						var style = { background: background };
						
					} else {
						var style = { 'backgroundColor': el[2] };
					}
				} else {
					style = {}
				}

				if (_.isArray(tagTitle)) {
					tagTitle = tagTitle.join(" + ")
				}

				return (
					<span key={index} ref="toggleInput"
						className="tag" data-tip={ tagTitle } data-for={ "text-area-markups" } style={ style }>
						{ el[0] }
						<ReactTooltip effect="float"  id={ "text-area-markups" }/>
					</span>
				); 
			} else {
				var el_array =  el[0].replace('</p><p>', '<br>').split(/\n|<br>/);
				if (el_array.length == 1) {
					el[0] = el[0].replace(HTML_TAG_PATTERN, "")
					return <span key={index}>{el[0]}</span>
				} else {
					return el_array.map(function(el_a,i) {
						el_a = el_a.replace(HTML_TAG_PATTERN, "")
						if (i < el_array.length - 1) {
							return ([<span key={ index }>{el_a}</span>, <br key={ "br" + index + "_1" }/>,<br key={ "br" + index + "_2" }/>])
						} else {
							return (<span key={ index }>{el_a}</span>)
						}
					})
				}
			}
		})
		return array
	}

	render() {
		return (
			<div className="textAreaMarkups">
				{ this.getElement(this.formatString(this.props.text, this.getMarkups())) }
			</div>
		);
	}
}

TextAreaMarkups.propTypes = StrictPropTypes({
	text: PropTypes.string.isRequired,

	// Either (legacy)...
	markups: PropTypes.array,

	// Or:
	tagging: PropTypes.object,
	tagColors: PropTypes.object,

	activeLeaf: PropTypes.object
});

module.exports = TextAreaMarkups;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/TextAreaMarkups.js